import { useLocalStorage } from "@vueuse/core";
import { createResource } from "frappe-ui";
import { computed, watch } from "vue";
import { refreshCart } from "./useCart";
import { Resource } from "@/types";

interface customer_t {
  name: string
  customer_name: string
}

const selectedCustomer = useLocalStorage("bookings-selected-customer", "")
const res: Resource<customer_t[]> = createResource({
  url: "bookings.ui.api.get_my_customers"
});

export function useSelectedCustomer() {
  return selectedCustomer
}

export function useSelectedCustomerInfo() {
  const avail = useAvailableCustomers()
  return computed(() => avail.value.find((x) => x.name === selectedCustomer.value))
}

export function setSelectedCustomer(val: string) {
  selectedCustomer.value = val
  refreshCart()
}

export function useAvailableCustomers() {
  if (!res.data && !res.loading && !res.fetched) {
    res.reload();
  }
  return computed(() => {
    return (res.data || []) as customer_t[];
  });
}

watch(() => res.data, () => {
  if (!res.data?.length) return;

  if (!selectedCustomer.value) {
    selectedCustomer.value = res.data[0]?.name
  } else if (!res.data.find((x) => x.name === selectedCustomer.value)) {
    selectedCustomer.value = res.data[0]?.name
  }
})
